import { render, staticRenderFns } from "./exhibition-activity-msg.vue?vue&type=template&id=c1221af4&scoped=true&"
import script from "./exhibition-activity-msg.vue?vue&type=script&lang=js&"
export * from "./exhibition-activity-msg.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-activity-msg.vue?vue&type=style&index=0&id=c1221af4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1221af4",
  null
  
)

export default component.exports